import styled, { css } from "styled-components";

interface IButton {
    noClickable?: boolean;
}

export const StyledButton = styled.button<IButton>(({ theme, noClickable }) => {
    return css`
        background: transparent;
        border: none;
        color: ${theme.palette.common.darkGray};
        font-family: ${theme.typography.base.main};
        display: flex;
        align-items: center;
        outline-color: ${theme.palette.common.black};
        padding: 7px 5px;
        & svg {
            margin: 0 3px;
            width: 38px;
        }
        & .button-value {
            margin-right: 3px;
        }
        cursor: ${noClickable ? "auto" : "pointer"};
    `;
});
